export default {
  props: {
    label: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },
    texts: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isOpened() {
      return this.open
    },

    toggleOptionsClasses() {
      if (this.open) return `select-accordion--open`
    },
  },

  methods: {
    toggleOptions() {
      this.open = !this.open
    },

    onChange(e) {
      const selectedOptions = e.detail.map((option) => option.value)
      this.$emit('onSelect', selectedOptions)
    },
  },
}
